import styled from "styled-components";
import { responsive } from "../../../../../../styles/constants.style";

export const ExistingDeliverableWrapper = styled.div`
  margin-top: 16px;

  .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root:first-of-type,
  .checkbox-cell {
    padding: 0 16px !important;
  }

  .cell-name {
    width: 290px;
  }

  .existing-header {
    padding-left: 16px;
    ${responsive.MOBILE`
       white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
       padding: 5px;
    `}
  }
`;
